import { TradeInEvent } from '../interfaces/interface.shift-digital-analytics';
import { sendTrackingEvent } from '../services/service.tracking';
import { state as shiftDigitalState } from '../store/store.tracking-shift-digital';

export function shiftDigitalTradeInEvent(event: TradeInEvent) {
  if (shiftDigitalState.isSDLoaded && shiftDigitalState.lastEvent !== event.events) {
    try {
      const data = {
        tradeInSessionId: shiftDigitalState.tradeInSessionId,
        tradeInProvider: shiftDigitalState.tradeInProvider,
        ...event,
      };
      window['sd']('dataLayer', data);
      window['sd']('send');
      shiftDigitalState.lastEvent = event.events;
    } catch (e) {
      console.log(`shiftDigital_${event}`, e);
    }
  }
}

export const shiftDigitalTradeInFormInitiation = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: 'tradeInFormInitiation',
    eventNonInteractive: false,
  });
};
